module.exports = __webpack_public_path__ + "images/home/product/mobile/features-statistic-d22290bfb6a01480ded029e68d8fe75b.png";